/**
 * Single source of truth for every game on the site.
 *
 * Imported by the React app AND by the Node build scripts
 * (scripts/generate-sitemap.js, scripts/prerender.js), so this file stays
 * CommonJS and free of JSX / browser APIs.
 */

const GAMES = [
  {
    key: "disawar",
    name: "Disawar",
    slug: "disawar-satta-result",
    aliases: ["Disawar Satta King", "Desawar", "Disawar Satta"],
    sheetId: "1FYrYD5kcn_I6K3mkFWk9hWa7oC-9nVo-Ok2FEqWkLYE",
    sheetIdsByYear: {
      2025: "1FYrYD5kcn_I6K3mkFWk9hWa7oC-9nVo-Ok2FEqWkLYE",
      2026: "1Oyys-k-cfPnKieEmAKF4w6KkF-NEqYrsNNhMt2hTV-k",
    },
    time24: "05:20",
    timeLabel: "5:20 AM",
  },
  {
    key: "bagad",
    name: "Bagad",
    slug: "bagad-satta-result",
    aliases: ["Bagad Satta King", "Bagad Satta Company", "Bagad Satta"],
    sheetId: "18jY7bveLJnvEo2Pv4x-hs3VI1_RZUMQ9BGZfv7XodgU",
    sheetIdsByYear: {
      2024: "144Gai1dAxjwrmBhl3N3POhAxUlZOtIeAeHyBMtVUrQ0",
      2025: "18jY7bveLJnvEo2Pv4x-hs3VI1_RZUMQ9BGZfv7XodgU",
      2026: "1U7r-G_hn3sxCYGEbmP4SxQnFdFbnqj7G_DdHADzZAUg",
    },
    time24: "13:30",
    timeLabel: "1:30 PM",
  },
  {
    key: "delhi-bazar",
    name: "Delhi Bazar",
    slug: "delhi-bazar-satta-result",
    aliases: ["Delhi Bazar Satta King", "Delhi Bazaar Result"],
    sheetId: "1GnxC1EbecGvETARz0e0JHizQm5UjQ7FACHwvpY7vPLo",
    sheetIdsByYear: {
      2025: "1GnxC1EbecGvETARz0e0JHizQm5UjQ7FACHwvpY7vPLo",
      2026: "1bI7oFX0Ea105MAxFiONOgzeGi8MKV8pJYLkXID13y2A",
    },
    time24: "15:15",
    timeLabel: "3:15 PM",
  },
  {
    key: "shri-ganesh",
    name: "Shri Ganesh",
    slug: "shri-ganesh-satta-result",
    aliases: ["Shri Ganesh Satta King", "Shree Ganesh Result"],
    sheetId: "1Um-PtpnyZaRu0BFarDqkUM0Izvg9rCquD3uit4PJnTk",
    sheetIdsByYear: {
      2025: "1Um-PtpnyZaRu0BFarDqkUM0Izvg9rCquD3uit4PJnTk",
      2026: "1wikUaU2I64YfzRa43_kiu5QMPWetQC3nwi-si4RIhX0",
    },
    time24: "16:45",
    timeLabel: "4:45 PM",
  },
  {
    key: "faridabad",
    name: "Faridabad",
    slug: "faridabad-satta-result",
    aliases: ["Faridabad Satta King", "Faridabad Satta"],
    sheetId: "1TK3Zwzb6-CfDUwO1nq-UZcIbDQDiKjRgmW9R9cZF_gk",
    sheetIdsByYear: {
      2025: "1TK3Zwzb6-CfDUwO1nq-UZcIbDQDiKjRgmW9R9cZF_gk",
      2026: "1oXgMXXe1YrpHJjf1UzIKG7OSosSxcUd-q87AN5p-iTw",
    },
    time24: "18:15",
    timeLabel: "6:15 PM",
  },
  {
    key: "jai-bhawani",
    name: "Jai Bhawani",
    slug: "jai-bhawani-satta-result",
    aliases: ["Jai Bhawani Satta King", "Jai Bhavani Result"],
    sheetId: "1GjS46eefP_HX4mVRZTXBScbq4EgZRt5s_1RjB44l_YQ",
    sheetIdsByYear: {
      2024: "1HSnnUcQHNAbXpD8g2ZsKxgf_ol4MxYWjNFXoZvpJk0U",
      2025: "1GjS46eefP_HX4mVRZTXBScbq4EgZRt5s_1RjB44l_YQ",
      2026: "1ElEdJJLGEToxPwS7SkpCgQdCd_MjJ1GjaF-WgU_-oXc",
    },
    time24: "19:15",
    timeLabel: "7:15 PM",
  },
  {
    key: "ghaziabad",
    name: "Ghaziabad",
    slug: "ghaziabad-satta-result",
    aliases: ["Ghaziabad Satta King", "Ghaziabad Satta"],
    sheetId: "1FTgPkLvQ_-h7Vllq_G6g-7aDUeHS0nlGQL2N1742mf0",
    sheetIdsByYear: {
      2025: "1FTgPkLvQ_-h7Vllq_G6g-7aDUeHS0nlGQL2N1742mf0",
      2026: "1EK98nvoSsQjfv2Fap4Ntzm5rdREIerY-_VUYgBMy1b8",
    },
    time24: "21:30",
    timeLabel: "9:30 PM",
  },
  {
    key: "jai-hanuman",
    name: "Jai Hanuman",
    slug: "jai-hanuman-satta-result",
    aliases: ["Jai Hanuman Satta King", "Jai Hanuman Satta"],
    sheetId: "1MAP3vTnhWb1c7ztcnJ9sXBAVfMrtOLKdn7YPHkhcgyw",
    sheetIdsByYear: {
      2024: "1WxvafsB0VkCPkw0oVjx6Any6PNmQn5ig30ZeoiF9At0",
      2025: "1MAP3vTnhWb1c7ztcnJ9sXBAVfMrtOLKdn7YPHkhcgyw",
      2026: "1ic0c1yTXsGpe6p3HfanDfjgf2zrr95V-Vh77_N88rrI",
    },
    time24: "22:20",
    timeLabel: "10:20 PM",
  },
  {
    key: "gogamedi",
    name: "Gogamedi",
    slug: "gogamedi-satta-result",
    aliases: ["Gogamedi Satta King", "Goga Medi Result"],
    sheetId: "1DBwbAhKjx2cK_yWq7eEeDmSKTjVvL5wCCYuMjSSZLzY",
    sheetIdsByYear: {
      2024: "1adPA0zpI0w_a2Uw7rhRXxijcIZt5L6ubX4BpljI1kgo",
      2025: "1DBwbAhKjx2cK_yWq7eEeDmSKTjVvL5wCCYuMjSSZLzY",
      2026: "13Z-AZtdkDNetrf7YYHq0GvTexxproetWHcqNaO6eTNk",
    },
    time24: "23:30",
    timeLabel: "11:30 PM",
  },
  {
    key: "gali",
    name: "Gali",
    slug: "gali-satta-result",
    aliases: ["Gali Satta King", "Gali Satta", "Gali Result"],
    sheetId: "1FYMs3eaPX06QHxzj1Szhz2N654sdllm1TY1CxmeC8hM",
    sheetIdsByYear: {
      2025: "1FYMs3eaPX06QHxzj1Szhz2N654sdllm1TY1CxmeC8hM",
      2026: "1Z7QNA7OcKZRUfGezV6vS1gTpUoW8sOtuKnzYj3mZoOs",
    },
    time24: "23:30",
    timeLabel: "11:30 PM",
  },
];

const GAMES_BY_TIME = [...GAMES].sort((a, b) => a.time24.localeCompare(b.time24));

function getGameBySlug(slug) {
  return GAMES.find((g) => g.slug === slug) || null;
}

module.exports = { GAMES, GAMES_BY_TIME, getGameBySlug };
